/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { QuoteTemplateShareButton_QuoteTemplateFragmentDoc } from './buttons/QuoteTemplateShareButton.generated.js';
export type TemplateQuoteWarnings_QuoteTemplateFragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, latestPublishedVersionNumber?: number | null, containsUnpublishedChanged: boolean, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, templateId: string, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null, sharedWithOrganisations: Array<{ __typename: 'Company', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } }> } | null };

export const TemplateQuoteWarnings_QuoteTemplateFragmentDoc = gql`
    fragment TemplateQuoteWarnings_QuoteTemplate on QuoteTemplate {
  id
  resolvedAsReadModelVersionNumber
  latestPublishedVersionNumber
  containsUnpublishedChanged
  owningSystemOrganisationId
  templateSharing {
    id
    latestSharedVersionNumber
    sharedPublicly
    subscribedToTemplate {
      subscribedVersionNumber
      updateAvailable
    }
  }
  ...QuoteTemplateShareButton_QuoteTemplate
}
    ${QuoteTemplateShareButton_QuoteTemplateFragmentDoc}`;